import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const AssignmentModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 44rem;
  max-width: 100%;
`

export const AssignmentDetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  width: 100%;
  padding: 1rem 0;
`

export const AssignmentDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const AssignmentDetailValue = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const AssignmentSerialsText = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  font-variant-numeric: tabular-nums;
`
